import styled from 'styled-components';

export const GridContainer = styled.div`
  width: 100%;
  min-height: 200px;
  overflow-x: visible;

  /* Canvas drag behavior: blue highlight + shadow when dragging (Figma spec) */
  .react-grid-item.react-draggable-dragging {
    box-shadow: 0 4px 16px rgba(43, 121, 255, 0.35);
    border: 2px solid ${(props) => props.theme.colors.blueCrayola || '#2B79FF'};
    background: rgba(43, 121, 255, 0.06);
    z-index: 10;
  }

  /* Drop zone placeholder: red overlay (Figma spec) */
  .react-grid-item.react-grid-placeholder {
    background: ${(props) => props.theme.colors.blueCrayola || '#2B79FF'};
    opacity: 0.2;
    border-radius: ${(props) => props.theme.borderRadius.base};
  }

  /* Resize handles: instant visibility on hover, no transition inheritance */
  .react-grid-item > .react-resizable-handle {
    transition: none;
  }
`;

export const GridItem = styled.div`
  width: 100%;
  height: 100%;
  min-height: 0;
`;
